import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import { Link, useHistory } from 'react-router-dom';
import AccountService from '../../services/accountInfo';
import TextInput from '../../shared/Fields/TextInput';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import styled from "styled-components";
import { Button } from "@material-ui/core";
import { useFormik } from 'formik';
import Validate from '../../helpers/validate';
import { toast } from 'react-toastify';
import AccountInfoModal from '../../shared/Modal/AccountInfoModal'
import SaveContentModal from '../../shared/Modal/SaveContentModal'
import moment from 'moment';
import { containerWidth } from '../../shared/constants'
import { getSeqSearchInit, submitSeqSearch } from '../../services/seqSearchService';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
    width: containerWidth,
    margin: '30px auto',
    minHeight: '260px',
    marginTop: '70px',
  },
  rootButton: {
    marginLeft: '-14px',
    '& > *': {
      margin: theme.spacing(2),
      textTransform: "capitalize",
    },
  },
  loginSubmitButton: {
    backgroundColor: '#db862c',
    marginLeft: '-6px',
    borderColor: '#ca751b',
    border: '1px solid #ca751b',
    color: 'white',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: '#db862c',
      boxShadow: 'none',
    },
  },
  loginSubmitDis: {
    backgroundColor: '#EEEEEE',
    marginLeft: '-6px',
    borderColor: '#CCCCCC',
    border: '1px solid #CCCCCC',
    color: '#777777',
    textTransform: 'capitalize',
    boxShadow: 'none !important',
    // '&:hover': {
    //   pointerEvents: 'none',
    //   boxShadow: 'none',
    // },
  },
  loginSubmitCancel: {
    backgroundColor: '#0182C5',
    // borderColor: '#1F4E79',
    border: '1px solid #1F4E79',
    color: 'white',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: '#0182C5',
      boxShadow: 'none',
    },
  },
  root: {
    '& > *': {
      margin: theme.spacing(2),
      textTransform: "capitalize",
    },
  },
  textBox: {
    width: '28%'
  }
}));

const textStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },

}));


function AccountInfo() {
  const [accountInfoData, setAccountInfoData] = useState([]);
  const [accountInfoNames, setAccountInfoNames] = useState([]);
  const [errorMessage, seterrorMessage] = useState("");
  const history = useHistory();
  const { t, i18n } = useTranslation('common');
  const [prop1, setProp1] = useState("prop1");
  const [modalShow, setModalShow] = React.useState(false);
  const [modalShowSaved, setmodalShowSaved] = React.useState(false);
  const [userIdCon, setuserIdCon] = useState("");
  const [userId, setuserId] = useState("");
  const [userFirstName, setuserfirstName] = useState("");
  const [userLastName, setuserlastName] = useState("");
  const [userEmail, setuserEmail] = useState("");
  const [userAccountingGroup, setuserAccountingGroup] = useState("");
  const [userAccountType, setuserAccountType] = useState("");
  const [userAccountCreated, setuserAccountCreated] = useState("");
  const [userAccountExpires, setuserAccountExpires] = useState("");
  const [userAccountClitoken, setuserAccountClitoken] = useState("");
  const [userAnalyses, setuserAnalyses] = useState("");
  const [userSeqDatabase, setuserSeqDatabase] = useState("");
  const [userUploads, setuserUploads] = useState("");
  const [ppuType, setPpuType] = useState();
  const [csrfToken, setCsrfToken] = useState();


  const toggle = useSelector(state => state.setToggle.toggle);

  const classes = useStyles();

  const GreyText = {
    marginTop: "30px",
    marginLeft: '36px',
    //color: "black",
    textAlign: "left"
  };
  const GreyTextDark ={
    marginTop: "30px",
    marginLeft: '36px',
    color: "white",
    textAlign: "left"
  };
  function successMessage() {
    setmodalShowSaved(false);
    history.push('/home')
  }
  function bytesToSize(bytes) {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0) return '0 Byte';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    let m = bytes / Math.pow(1024, i);
    let s = sizes[i+1] == sizes.length ?  m.toFixed(2) + ' ' + 'TB': m.toFixed(2) + ' ' + sizes[i+1]
    return s;
  }
  function setAccountInfo(data) {
    if (data) {
      data.csrf_token ? setCsrfToken(data.csrf_token) : setCsrfToken("");
      data.id ? setuserIdCon(data.id) : setuserIdCon('');
      data.login_name ? setuserId(data.login_name) : setuserId('');
      data.email ? setuserEmail(data.email) : setuserEmail('');
      data.accounting_group_name ? setuserAccountingGroup(data.accounting_group_name) : setuserAccountingGroup('');
      data.user_class_name ? setuserAccountType(data.user_class_name) : setuserAccountType('');
      // moment(values.docPublicDate).format('YYYYMMDD') moment(data.expire_time).format("MMMM Do YYYY"))  moment(data.expire_time).format("LL"))
      data.create_time ? setuserAccountCreated(data.create_time) : setuserAccountCreated('');
      data.expire_time ? setuserAccountExpires('After ' + moment(data.expire_time).format("LL")) : setuserAccountExpires('Never');
      data.clitoken ? setuserAccountClitoken(data.clitoken) : setuserAccountClitoken('');
      data.dspace_workflow ? setuserAnalyses(bytesToSize(data.dspace_workflow)) : setuserAnalyses(0);
      data.dspace_seqdb ? setuserSeqDatabase(bytesToSize(data.dspace_seqdb)) : setuserSeqDatabase(0);
      data.dspace_uploaded ? setuserUploads(bytesToSize(data.dspace_uploaded)) : setuserUploads(0);
      data.first_name ? setuserfirstName(data.first_name) : accountInfoData && accountInfoData.first_name ? setuserfirstName(accountInfoData.first_name) : setuserfirstName('');
      data.last_name ? setuserlastName(data.last_name) : accountInfoData && accountInfoData.last_name ? setuserlastName(accountInfoData.last_name) : setuserlastName('');
    }
  }
  useEffect(() => {
    async function fetchMyAPI() {
      let resp;
      const result = await AccountService.getAccountInfo(history);
      console.log(result);
      resp = await getSeqSearchInit(history, null);
      if(result.response_content.ppu_type === '1' || result.response_content.ppu_type === 1
          || result.response_content.ppu_type === '2' || result.response_content.ppu_type === 2){
        setPpuType(resp.response_content.group_credits);
      }
      document.title = 'GenomeQuest - Account Settings'
      if (result && result.response_content) {
        setAccountInfoData(result.response_content);
        setAccountInfo(result.response_content)
      } else {
        setAccountInfoData([]);
        history.push('/home');
      }
    }
    fetchMyAPI()
  }, [])

  const formik = useFormik({
    initialValues: {
      firstName: accountInfoData.first_name ? String(accountInfoData.first_name) : '',
      lastName: accountInfoData.last_name ? String(accountInfoData.last_name) : '',
      confirmPassword: '',

    },
    enableReinitialize: true,
    validationSchema: Validate.InformationDataValidate(),
    onSubmit: async (values) => {
      const result = await AccountService.updateUser(parseInt(userIdCon), values.firstName, values.lastName, values.confirmPassword, csrfToken, history);
      if (result.response_content.message) {

        await seterrorMessage(result.response_content.message);
        setModalShow(true);
        // toast.error(result.response_content.message);
      } else {
        // toast.success("Successfully Updated");
        // history.push('/home')
        setmodalShowSaved(true);
      }
    },
  });
  const TableContainer = styled.div`
      table {
          margin-left: 70px;
          margin-top: 37px;
          width:80%;
        tr {
          border-bottom: 2px solid #dee2e6;
          border-top: 2px solid #dee2e6;
          :first-child {
            // border-top: 2px solid #dee2e6;
          }
        }
        td {
          color: 'black';
          :first-child {
            border-right: 2px solid white;
            width: 180px;
          }
          :last-child {
            padding-left: 20px;

          }
        }
      }
    `;
  const TextLeft = {
    textAlign: "left",
    marginLeft: "70px"
  };
  function homePage() {
    history.push('/home');
  }
  function tryAgainForm() {
    formik.setFieldValue('confirmPassword', '');
    setModalShow(false)
  }
  const passwordVlaue = formik.values.confirmPassword;
  const passValCheck = passwordVlaue.length;

  function cancelForm() {
    setModalShow(false);
    history.push('/home');

  }
  return (

    <div className={classes.grow}>
      <form name="accountInformationForm" onSubmit={formik.handleSubmit} >
        <div>
        <h5 style={toggle? GreyText : GreyTextDark}>{t('yourdetails')}</h5>
          <div>
            <div style={TextLeft}>
              <br></br>
              <TextInput
                className={classes.textBox}
                id="firstName"
                name="firstName"
                label='First Name'
                variant="outlined"
                inputProps={{
                  maxLength: 64
                }}
                value={formik.values.firstName}
                onChange={formik.handleChange}
                error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                helperText={formik.touched.firstName && formik.errors.firstName}
              />
              &nbsp;&nbsp;
              <TextInput
                className={classes.textBox}
                id="lastName"
                //  initialValues={userLastName}
                inputProps={{
                  maxLength: 64
                }}
                name="lastName"
                label='Last Name'
                variant="outlined"
                value={formik.values.lastName}
                onChange={formik.handleChange}
                error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                helperText={formik.touched.lastName && formik.errors.lastName}
              />
            </div>
            <TableContainer>
              <Table aria-label="simple table">
                <TableBody>
                  <TableRow>
                    <TableCell align="left" style={toggle? {color: 'black',borderRight: '1px solid #dee2e6'}:{color: 'white', borderRight: '1px solid white'} }>{t('aiuserid')}</TableCell>
                    <TableCell align="left" style={toggle? {color: 'black'}:{color: 'white'} }>{userId}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left" style={toggle? {color: 'black',borderRight: '1px solid #dee2e6'}:{color: 'white', borderRight: '1px solid white'} }>{t('aiemail')}</TableCell>
                    <TableCell align="left" style={toggle? {color: 'black'}:{color: 'white'} }>{userEmail}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
        <div>
          <h5 style={toggle? GreyText : GreyTextDark}>{t('aiaccount')}</h5>
          <div>
            <TableContainer>
              <Table aria-label="simple table">
                <TableBody>
                  <TableRow >
                    <TableCell align="left" style={toggle? {color: 'black',borderRight: '1px solid #dee2e6'}:{color: 'white', borderRight: '1px solid white'} }>{t('aiaccgroup')}</TableCell>
                    <TableCell align="left" style={toggle? {color: 'black'}:{color: 'white'} }>{userAccountingGroup}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left" style={toggle? {color: 'black',borderRight: '1px solid #dee2e6'}:{color: 'white', borderRight: '1px solid white'} }>{t('aiacctype')}</TableCell>
                    <TableCell align="left" style={toggle? {color: 'black'}:{color: 'white'} }>{userAccountType}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left" style={toggle? {color: 'black',borderRight: '1px solid #dee2e6'}:{color: 'white', borderRight: '1px solid white'} }>{t('aiaccreated')}</TableCell>
                    <TableCell align="left" style={toggle? {color: 'black'}:{color: 'white'} }>{userAccountCreated}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left" style={toggle? {color: 'black',borderRight: '1px solid #dee2e6'}:{color: 'white', borderRight: '1px solid white'} }>{t('aiaccexp')}</TableCell>
                    <TableCell align="left" style={toggle? {color: 'black'}:{color: 'white'} }>{userAccountExpires}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left" style={toggle? {color: 'black',borderRight: '1px solid #dee2e6'}:{color: 'white', borderRight: '1px solid white'} }>{t('aiclitoken')}</TableCell>
                    <TableCell align="left" style={toggle? {color: 'black'}:{color: 'white'} }>{userAccountClitoken}</TableCell>
                  </TableRow>
                  {ppuType &&
                  <TableRow >
                    <TableCell align="left" style={toggle? {color: 'black',borderRight: '1px solid #dee2e6'}:{color: 'white', borderRight: '1px solid white'} }>{t("aisearchCredit")}</TableCell>
                    <TableCell align="left" style={toggle? {color: 'black'}:{color: 'white'} }>{ppuType}</TableCell>
                  </TableRow>
                  }
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
        <div>
          <h5 style={toggle? GreyText : GreyTextDark}>{t('aistorage')}</h5>
          <div>
            <TableContainer>
              <Table aria-label="simple table">
                <TableBody>
                  <TableRow>
                    <TableCell align="left" style={toggle? {color: 'black',borderRight: '1px solid #dee2e6'}:{color: 'white', borderRight: '1px solid white'} }>{t('aianalyses')}</TableCell>
                    <TableCell align="left" style={toggle? {color: 'black'}:{color: 'white'} }>{userAnalyses}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left" style={toggle? {color: 'black',borderRight: '1px solid #dee2e6'}:{color: 'white', borderRight: '1px solid white'} }>{t('aiseqdatabase')}</TableCell>
                    <TableCell align="left" style={toggle? {color: 'black'}:{color: 'white'} }>{userSeqDatabase}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left" style={toggle? {color: 'black',borderRight: '1px solid #dee2e6'}:{color: 'white', borderRight: '1px solid white'} }>{t('aiuploads')}</TableCell>
                    <TableCell align="left" style={toggle? {color: 'black'}:{color: 'white'} }>{userUploads}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
        <div>
          <h5 style={toggle? GreyText : GreyTextDark}>{t('aiapplychange')}</h5>
          <div>
            <div style={TextLeft}>
              <br></br>
              <div >
                <TextInput
                  className={classes.textBox}
                  id="confirmPassword"
                  name="confirmPassword"
                  label='Current Password'
                  variant="outlined"
                  type="password"
                  value={formik.values.confirmPassword}
                  onChange={formik.handleChange}
                  error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
                  helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
                />
              </div>

              <div className={classes.rootButton}>
                <Button variant="contained" disableRipple={true} className={classes.loginSubmitCancel} onClick={homePage}>{t('cancel')}</Button>


                {passValCheck != 0 ? <Button variant="contained" disableRipple={true} className={classes.loginSubmitButton} type="submit">
                  {t('aisavechange')}
                </Button>
                  :
                  <Button variant="contained" disableRipple={true} color="default" className='cancelButtonAI'  >
                    {t('aisavechange')}
                  </Button>
                }
                {/* <Button  className='cancelButtonDisable' color="default" disableRipple={true}  variant="contained">Delete Selected Saved Search Forms</Button>  */}
              </div>
              {/* <Button {(passwordForm ? 'd-block' : 'd-none')} variant="contained" disableRipple='true' type="submit">{t('aisavechange')}</Button> */}
              {/* <Button color="primary" variant="contained" className="float-right loginSubmit text-capitalize" type="submit">
                            Submit

             </Button> */}
            </div>
            <AccountInfoModal
              show={modalShow}
              onHide={() => cancelForm()}
              tryAgain={() => tryAgainForm()}
              onMessage={errorMessage}
            />
            <SaveContentModal
              show={modalShowSaved}
              onHide={() => successMessage()}
              onMessage={'Your changes have been saved.'}
              type="seqSearch"
            />
          </div>
        </div>
      </form>
    </div>

  )
}

export default AccountInfo;
